import { useState } from 'react';
import { Container } from './styled';
import { Charts, ChartFull } from '../../../../../components';
import { GiResize } from "react-icons/gi";

export function ChartCompany({ company, objKey }) {

    const { empresa_nome, empresa_avatar, dados } = company;

    const [openFullChart, setOpenFullChart] = useState(false);


    const generateChartData = (data) => {
        const chartData = {
            labels: data?.map(item => (item[objKey])),
            datasets: [
                {
                    label: 'Tempo em Horas',
                    data: data?.map(item => (item?.tempo_horas)),
                    backgroundColor: 'rgba(75, 192, 192, 1)',
                    borderColor: 'rgba(75, 192, 192, 1)',
                    borderWidth: 2,
                    fill: false,
                },
            ],
        };
        return chartData
    };

    return (
        <>
            <Container>
                <div className='info--'>
                    <div className='logo--'>
                        <img
                            src={empresa_avatar}
                            alt={`avatar--`}
                        />
                    </div>
                    <div className='name--company'>
                        <span>
                            {` - ${empresa_nome}`}
                        </span>
                    </div>
                </div>
                <div className='full--'>
                    <span onClick={() => setOpenFullChart(true)}>
                        <GiResize fontSize={'1.75rem'} />
                    </span>
                </div>
                <div className='--chart'>
                    <Charts
                        type='Bar'
                        data={generateChartData(dados)}
                    />
                </div>
            </Container >
            {(openFullChart) &&
                (<ChartFull
                    onClose={() => setOpenFullChart(false)}
                    title={`${empresa_nome}`}
                    dataChart={
                        {
                            type: "Bar",
                            data: generateChartData(dados)
                        }
                    }
                />)
            }
        </>

    );
}
